var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTab5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V41.1667L6.5 36.8333L13 41.1667L19.5 36.8333L22.3167 38.6967C21.8833 37.44 21.6667 36.075 21.6667 34.6667C21.668 32.5872 22.1678 30.5383 23.1241 28.6918C24.0804 26.8453 25.4653 25.2549 27.1629 24.0538C28.8605 22.8528 30.8212 22.0762 32.8807 21.789C34.9403 21.5018 37.0386 21.7125 39 22.4033V0H0ZM30.3333 8.66667V13H8.66667V8.66667H30.3333ZM26 17.3333V21.6667H8.66667V17.3333H26ZM34.6667 31.6333L30.1167 27.0833L27.0833 30.1167L31.6333 34.6667L27.0833 39.2167L30.1167 42.25L34.6667 37.7L39.2167 42.25L42.25 39.2167L37.7 34.6667L42.25 30.1167L39.2167 27.0833L34.6667 31.6333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V41.1667L6.5 36.8333L13 41.1667L19.5 36.8333L22.3167 38.6967C21.8833 37.44 21.6667 36.075 21.6667 34.6667C21.668 32.5872 22.1678 30.5383 23.1241 28.6918C24.0804 26.8453 25.4653 25.2549 27.1629 24.0538C28.8605 22.8528 30.8212 22.0762 32.8807 21.789C34.9403 21.5018 37.0386 21.7125 39 22.4033V0H0ZM30.3333 8.66667V13H8.66667V8.66667H30.3333ZM26 17.3333V21.6667H8.66667V17.3333H26ZM34.6667 31.6333L30.1167 27.0833L27.0833 30.1167L31.6333 34.6667L27.0833 39.2167L30.1167 42.25L34.6667 37.7L39.2167 42.25L42.25 39.2167L37.7 34.6667L42.25 30.1167L39.2167 27.0833L34.6667 31.6333Z",
    fill: "url(#paint0_linear_444_5341)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_444_5341",
    x1: 39.5092,
    y1: -2.5751,
    x2: -7.23667,
    y2: 32.3843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3AACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab5);
export default __webpack_public_path__ + "static/media/tab-5.96770dc26326697fa33b5efc8b26d520.svg";
export { ForwardRef as ReactComponent };